// extracted by mini-css-extract-plugin
export default {"centered":"global_centered__yQUED"};